import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import forgottenPassword from '../../actions/forgottenPassword';

import {motion} from 'framer-motion';

import {authAnimation} from '../../animations';

const ForgottenPassword = () => {

    const [email, setEmail] = useState('');
    const [forgottenText, setForgottenText] = useState('Send password reset');

    const dispatch = useDispatch();

    const {forgottenError, forgottenSuccess} = useSelector((state) => state.user)

    const handleSubmit = (evt) => {
        evt.preventDefault();

        setForgottenText( 'Loading...' );

        // You have access to email & password here.
        dispatch(forgottenPassword({email}));
    }

    useEffect(() => {
        if ( forgottenError || forgottenSuccess ) {
            setForgottenText( 'Send password reset' );

            setTimeout(() => {
                dispatch({type: 'RESET_ERRORS'})
            }, 3000)
        }
    }, [forgottenError, forgottenSuccess]);

    return (
        <motion.div
        layoutId="auth"
        key="forgottenPassword"
        variants={authAnimation}
        initial="initial"
        animate="visible"
        exit="exit">

            <h2 className="is-3">Reset your password</h2>
            <p>Password slipped your memory? Reset it now</p>

            <form onSubmit={handleSubmit} autoComplete="off">

                <div className="errors">
                    {forgottenError ?
                        <div className="alert error">{forgottenError}</div>
                    : ''}

                    {forgottenSuccess ?
                        <div className="alert success">{forgottenSuccess}</div>
                    : ''}
                </div>

                <input
                required
                type="email"
                value={email}
                placeholder="Email address *"
                onChange={e => setEmail(e.target.value)} />

                <button type="submit" className="button login">{forgottenText}</button>
            </form>
        </motion.div>
    );
}

export default ForgottenPassword;
